import type { CommandUnknownOpts } from '@commander-js/extra-typings';
import type { ErrorReporter } from '@wix/cli-error-reporting';

interface HooksOptions {
  errorReporter: ErrorReporter;
}

const getFullCommandName = (command: CommandUnknownOpts): string => {
  if (command.parent) {
    return `${getFullCommandName(command.parent)} ${command.name()}`.trim();
  }
  return command.name();
};

export function addCommandInfoToErrorReports(
  program: CommandUnknownOpts,
  { errorReporter }: HooksOptions
) {
  program.hook('preAction', (_, actionCommand) => {
    const command = getFullCommandName(actionCommand);

    errorReporter.setContext('command info', {
      args: actionCommand.args,
      command,
      opts: actionCommand.opts(),
    });
  });
}
